export const types = {
	GET_BADGE_NOTIFICATIONS: 'NOTIFICATIONS_BADGE/GET_NOTIFICATIONS',
	GET_TOTAL_BADGE_NOTIFICATIONS: 'NOTIFICATIONS_BADGE/GET_TOTAL_NOTIFICATIONS',
	SET_TOTAL_BADGE_NOTIFICATIONS_LOADED: 'NOTIFICATIONS_BADGE/NOTIFICATIONS_TOTAL_LOADED',
	SET_BADGE_ACTIVE: 'NOTIFICATIONS_BADGE/SET_BADGE_ACTIVE',
	SET_BADGE_NOTIFICATIONS: 'NOTIFICATIONS_BADGE/SET_NOTIFICATIONS',
	STOP_POLLING: 'NOTIFICATIONS_BADGE/STOP_POLLING',
	UPDATE_SHOW_PRELOADER: 'NOTIFICATIONS_BADGE/UPDATE_SHOW_PRELOADER'
};

export const actions = {
	getNotifications: () => ({ type: types.GET_BADGE_NOTIFICATIONS }),
	getTotalNotifications: () => ({
		type: types.GET_TOTAL_BADGE_NOTIFICATIONS
	}),
	setBadgeActive: setAnimate => ({ type: types.SET_BADGE_ACTIVE, setAnimate }),
	setNotifications: notifications => ({
		type: types.SET_BADGE_NOTIFICATIONS,
		notifications
	}),
	stopPolling: () => ({ type: types.STOP_POLLING }),
	setTotalNotificationsLoaded: data => ({
		type: types.SET_TOTAL_BADGE_NOTIFICATIONS_LOADED,
		data
	}),
	updateShowPreloader: bool => ({ type: types.UPDATE_SHOW_PRELOADER, bool })
};
